//FUTURE UPDATES
//save user prefs to DB to auto-sync in all user's devices

import rowPerPage from '@/constants/rows-per-page.js';

const DEFAULT_ROWS = 5

// Flatten allowed values to numbers and "All" for validation
const ALLOWED_ROWS = rowPerPage.map(item => (typeof item === 'number' ? item : 'All'))

export default {
    getRowsPerPage(pageName) {
        if (!pageName) return DEFAULT_ROWS

        const stored = localStorage.getItem(`rowsPerPage_${pageName}`)
        
        if (stored === null) return DEFAULT_ROWS

        const value = stored === 'All' ? -1 : parseInt(stored)
        const returnValue = ALLOWED_ROWS.includes(stored === 'All' ? 'All' : value) ? value : DEFAULT_ROWS
    
        return returnValue
    },
    updateRowsPerPage(pageName, rows) {
        if (!pageName) return

        // Normalize -1 to "All" for storage
        const storeValue = rows === -1 ? 'All' : rows

        if (!ALLOWED_ROWS.includes(storeValue)) {
            console.warn(`Invalid rows value: ${rows}. Allowed: ${ALLOWED_ROWS.join(", ")}`)
            return
        }

        localStorage.setItem(`rowsPerPage_${pageName}`, storeValue)
    },
    getViewAllSwitch(pageName) {
        if (!pageName) return false

        const stored = localStorage.getItem(`viewAllSwitch_${pageName}`)
        if (stored === null) return false

        // Convert string to boolean
        return stored === 'true'
    },
    updateViewAllSwitch(pageName, value) {
        if (!pageName) return

        // Always store as string
        localStorage.setItem(`viewAllSwitch_${pageName}`, value ? 'true' : 'false')
    },
    getSort(pageName) {
        if (!pageName) return { sortBy: null, descending: false }

        const stored = localStorage.getItem(`sort_${pageName}`)
        return stored ? JSON.parse(stored) : { sortBy: null, descending: false }
    },
    updateSort(pageName, sortBy, descending) {
        if (!pageName) return
        
        localStorage.setItem(
            `sort_${pageName}`,
            JSON.stringify({ sortBy, descending })
        )
    },
    getCalendarYear(pageName) {
        if (!pageName) return null

        const stored = localStorage.getItem(`calendarYear_${pageName}`)
        return stored ? parseInt(stored) : new Date().getFullYear()
    },
    updateCalendarYear(pageName, calendarYear) {
        if (!pageName) return
        if (typeof calendarYear !== 'number' || isNaN(calendarYear)) {
            console.warn(`Invalid calendarYear: ${calendarYear}`)
            return
        }

        localStorage.setItem(`calendarYear_${pageName}`, calendarYear.toString())
    },
    getSearchKeyword(pageName) {
        if (!pageName) return null

        const stored = localStorage.getItem(`searchKeyword_${pageName}`)
        return stored && stored.trim() !== '' ? stored : null
    },
    updateSearchKeyword(pageName, value) {
        if (!pageName) return

        if (!value || value.trim() === '') {
            localStorage.removeItem(`searchKeyword_${pageName}`)
        } else {
            localStorage.setItem(`searchKeyword_${pageName}`, value)
        }
    },
    getSelectedCompensationYear(){
        const stored = localStorage.getItem(`selectedCompensationYear`)
        return stored && stored.trim() !== '' ? stored : new Date().getFullYear()
    },
    updateSelectedCompensationYear(year) {
        if (!year) return
        localStorage.setItem(`selectedCompensationYear`, year)
    },
    getExpandCollapseVisibility(pageName, section) {
        if (!pageName) return false

        const stored = localStorage.getItem(`Expand_Collapse_Visibility_${pageName}_${section}`)
        if (stored === null) return true //default to expanded

        // Convert string to boolean
        return stored === 'true'
    },
    updateExpandCollapseVisibility(pageName, section, value) {
        if (!pageName) return

        // Always store as string
        localStorage.setItem(`Expand_Collapse_Visibility_${pageName}_${section}`, value ? 'true' : 'false')
    },
};
